import { render, staticRenderFns } from "./TaskFamilyTable.vue?vue&type=template&id=53d816ad"
import script from "./TaskFamilyTable.vue?vue&type=script&lang=js"
export * from "./TaskFamilyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports